export const typeCheckBox="checkBox";
export const typeTextArea="textArea";
export const typeSelect="select";
export const typeTextWithOnChangeEvent="TextWithonChangeEvent";
export const typeCheckBoxWithChangeEvent="typeCheckBoxWithChangeEvent";
export const emailRegex= /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const zipcodeSwedishRegExp=/^(s-|S-){0,1}[0-9]{3}\s?[0-9]{2}$/g;
export const  onlyDigits = /^\d+$/;
export const shipClassIdFishingShip="Fiskefartyg";

export const callsignReqFor=["Fritidsfartyg","Ospecifierad"];
export const MinBoatSizeLengthForLeisureBoatAndDisplayCallsign=15;


